export default __webpack_public_path__ + "static/media/ic_done.ecbf2319.svg";